import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicCreateEvent = () => {
  const { auth, setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);
  const isSmallDevise = windowWidth < 900;  
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Premiers pas', link: '/topics/about/first-step'},
    { label: topic.title, link: topic.link},
  ]
  
  
  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-12 w-help-title'
      />
      <div className="help-content-container mt-0">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Ça y est, vous êtes sur le point de publier votre event unique, c'est le votre. C'est parti ! 
              Une fois que les équipes de Wodzone vous ont accordé(e) un token, vous pouvez créer une nouvelle annonce en toute simplicité depuis la section 
              Admin de votre profil.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                La méthode la plus simple et rapide consiste à <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>contacter</a> directement les équipes de Wodzone.
                Elles se feront un plaisir de répondre à vos questions, de vous guider pas à pas et de vous proposer la configuration la mieux adaptée à vos besoins.
                Vous recevrez ensuite un devis détaillé, accompagné d’une demande d’acompte pour les frais de dossier. Une fois le paiement effectué, vous obtiendrez 
                immédiatement tout ce qu’il vous faut pour créer votre évent.
              </p>
              <p className="help-text">
                Vous pouvez également jeter un coup d'oeil sur le site
                <a target='_blank' className="link" href="https://wodzone.fr">https://wodzone.fr</a>
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part mb-8">{topic.subtitles[1]}</p>
              <p className="help-text">
                Après avoir obtenu votre token, vous verrez apparaître un nouveau lien<a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>Admin</a>dans votre profil.
                Depuis cet espace, accédez à votre tableau de bord pour créer votre premier événement et gérer tous les aspects administratifs : 
                page compétition, catégories, WODs, planning, et bien plus encore.
              </p>
              <p className="help-text">
                Pour en savoir plus sur comment <a target='_blank' className="link" href="#">administrer ma compétition.</a>
              </p>
            </div>
            <div className="article-container mt-56">
              <p className="help-title-part mb-8">{topic.subtitles[2]}</p>
              <p className="help-text">
                Votre compétition apparaîtra dans les résultats de recherche uniquement si elle a été publiée ou si la programmation de sa diffusion est arrivée à échéance.
                Pour gérer<a target='_blank' className="link" href="#">la publication</a>
              </p>
              <p className="help-text">
                Si la compétition n'est pas encore publiée, elle restera visible <strong>uniquement</strong> pour vous et les autres membres organisateurs. 
                Cela vous permet de prévisualiser la page avant de la partager avec vos athlètes.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )

}

export default HelpTopicCreateEvent